import { createContext, useContext } from "react";
import { LineType } from "src/routes/libraries/plan-package/takeoffs/components/AddItems/utils";

export type TakeoffsSidePanelMode =
  | { kind: "edit"; tliId: string }
  | { kind: "add"; type: LineType }
  | { kind: "duplicate"; tliId: string }
  | { kind: "bulkEdit" };

/** The modes `TakeoffLinePanel` shows a single line for */
export type SingleLinePanelMode = Exclude<TakeoffsSidePanelMode, { kind: "bulkEdit" }>;

export type TakeoffsSidePanelContextValue = {
  activeTliId: string | undefined;
  // `openEdit`, `openAdd`, `openDuplicate`, `openBulkEdit` and `closePanel` ask first when the panel has unsaved changes
  openEdit: (tliId: string) => void;
  openAdd: (type: LineType) => void;
  openDuplicate: (tliId: string) => void;
  /** Bulk edits the table's selection */
  openBulkEdit: VoidFunction;
  closePanel: VoidFunction;
  /** Closes without asking, e.g. Bulk Edit once nothing is selected */
  dismissPanel: VoidFunction;
  /** Switches the panel to a line without asking, e.g. the one just added */
  showLine: (tliId: string) => void;
  /** Closes the panel if it shows a line that was just deleted */
  lineDeleted: (tliId: string) => void;
  /** The panel's form reports whether it's dirty; returns the unregister */
  registerDirtyCheck: (isDirty: () => boolean) => VoidFunction;
};

export const TakeoffsSidePanelContext = createContext<TakeoffsSidePanelContextValue | undefined>(undefined);

export function useTakeoffsSidePanel(): TakeoffsSidePanelContextValue {
  const value = useContext(TakeoffsSidePanelContext);
  if (!value) throw new Error("Missing TakeoffsSidePanelProvider");
  return value;
}
